import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from 'react-redux';
import {apiRequest} from 'util/api/util'
import ReactDOM from 'react-dom'
import moment from 'moment';
import ReactTable from 'react-table';
import Button from "components/CustomButtons/Button.js";
import EmailIcon from '@material-ui/icons/Email';
import {CSVLink, CSVDownload} from 'react-csv';
import IconButton from '@material-ui/core/IconButton'
import SweetAlert from 'react-bootstrap-sweetalert'
import { refundUserReservation } from 'util/api/CheckoutAPI'

function RefundButton({reservationId}) {

  const [alert, setAlert] = React.useState(null)

  const handleRefundClicked = (e) => {
    e.preventDefault()

    setAlert(
      <SweetAlert
      danger
      showCancel
      confirmBtnText="Yes, refund"
      confirmBtnBsStyle="danger"
      title="Are you sure?"
      onConfirm={() => {
        // dispatch(refundUserReservation(reservation.id))
        setAlert(false)
        refundUserReservation(reservationId)
        // setAlert(
        // <SweetAlert 
        // title={`Canceled`}
        // onConfirm={() => setAlert(false)}
        // onCancel={() => setAlert(false)}
        // >
        //   <div>Your class has been canceled. Thanks for letting us know!</div>
        //   <br></br>
        //   <div>If you purchased this class you will receive a refund in the next 3-5 days</div>
        // </SweetAlert>
        // )
      }
      }
      onCancel={() => setAlert(false)}
      focusCancelBtn
    >
      Are you sure you want to issue a refund?
      <br></br>
      <br></br>
      When a refund has been processed, the status of this payment will change from "completed" to "refunded"
    </SweetAlert>
    )

  }

  return (
    <>
      {alert}
      <button onClick={handleRefundClicked} className="btn btn-link _danger">Refund</button>
    </>
  )
}

function PaymentsTable(props) {

  const user = useSelector(state => state.user.userData)

  const [reservations, setReservations] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)

  useEffect(() => {
    if (!user.platformID) {
      console.log("no classId")
      return  
    }

    setIsLoading(true)
    apiRequest(`clients/reservations?partnerId=${user.platformID}&limit=1000`)
    // apiRequest(`clients?clientId=${selectedUserId}&partnerId=${partnerId}`)
      .then(reservations => {
          console.log(data)
          // const {user, purchases, reservations} = data
          // setClientData(user)
          // setPurchases(purchases)classStartTime
          setReservations(reservations)
          setIsLoading(false)
      })
      .catch(err => {
        console.log(err)
        setIsLoading(false)
      })

    


    
  }, [user])
  // const reservations = useSelector(state => state.instructor.reservations);

  const data = reservations.sort( (a, b) => {
      if (a.classStartTime && b.classStartTime) {
        return b.created - a.created
      } else {
        return 0
      }
    })
    .map(val => {
      return {
        ...val,
        // payment: payment,
        // title: title,
        paid: val.canceled ? "canceled" : val.paid,
        student_name: `${val.firstName} ${val.lastName}`,
        dateCreatedISO: moment(val.created * 1000).toISOString(),
        classStartISO: moment(val.classStartTime * 1000).toISOString()
      }
    })
    function handleExport() {
      const headers = [
        {label: "Date Purchased", key: "dateCreated"},
        {label: "Date Purchase ISO", key: "dateCreatedISO"},
        {label: "Canceled", key: "canceled"},
        {label: "Location", key: "locationType"},
        {label: "Class Name", key: "className"},
        {label: "Class Start Date", key: "classStart"},
        {label: "Class Start Date ISO", key: "classStartISO"},
        {label: "First Name", key: "firstName"},
        {label: "Last Name", key: "lastName"},
        {label: "Email", key: "email"},
        {label: "Reservation Type", key: "reservationType"},
        {label: "Paid", key: "paid"},
        {label: "Package Name", key: "purchaseName"},
        {label: "Package Period Start", key: "purchasePeriodStart"},
        {label: "Package Period End", key: "purchasePeriodEnd"},
        {label: "Amount Paid", key: "amountPaid"},
        {label: "classID", key: "classID"},
        {label: "Duration", key: "duration"},
        {label: "Instructor", key: "instructor"},
        {label: "Categories", key: "categories"},
        {label: "Class Timestamp", key: "classStartTime"},
        {label: "Checked In", key: "checkedIn"}
      ]
      // const cleanedData = data.map(val => {
      //   return {
      //     date_purchased: moment(val.date * 1000).format('MMMM Do, h:mm a'),
      //     status: val.status,
      //     sales: `$${(val.revenue / 100)}`,
      //     class: val.class.name,
      //     class_time: moment(val.class_time * 1000).format('MMMM Do, h:mm a'),
      //     client_name: val.student_name,
      //     agree_to_marketing: val.agree_to_marketing,
      //     client_email: val.email,
      //     class_type: val.class.type
      //   }
      // })
      const element = (<CSVDownload data={data} headers={headers} target="_blank" />);

      ReactDOM.render(element, document.querySelector('#export-reservations-div'));
    }

  // return (<></>)

  return (
    <div>
      <div className="d-flex flex-row-reverse">
        <Button onClick={handleExport} size={"sm"}>Export to CSV</Button>
        <div id='export-reservations-div'></div>
      </div>
      <ReactTable
              loading={isLoading}
              data={data}
              filterable
              columns={[
                  {
                  Header: "Date Purchased",
                  accessor: "created",
                  // filterable: false,
                  sort: 'desc',
                  Cell: row => <span>{moment(row.value * 1000).format('MMMM Do, h:mm a')}</span>
                  },
                  {
                  Header: "Type",
                  accessor: "locationType",
                  width: 100
                  },
                  {
                  Header: "Name",
                  accessor: "className"
                  },
                  {
                  Header: "Class Time",
                  accessor: "classStart"
                  },
                  {
                  Header: "Student",
                  accessor: "student_name"
                  },
                  {
                  Header: "Email",
                  accessor: "email"
                  },
                  {
                  Header: "Purchase Type",
                  // id: 'reservationType',
                  accessor: "reservationType",
                  width: 100
                  },
                  {
                  Header: "Paid",
                  accessor: "paid",
                  width: 50
                  },
                  {
                  Header: "Package Name",
                  accessor: "purchaseName",
                  width: 160
                  },
                  // {
                  // Header: "Status",
                  // accessor: "status",
                  // width: 100
                  // },
                  // {
                  // Header: "Actions",
                  // accessor: "actions",
                  // width: 100
                  // }
              ]}
              defaultPageSize={20}
              showPaginationTop={false}
              showPaginationBottom={true}
              className="-highlight"
              />
      </div>
  );
}

export default PaymentsTable;